
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/category/[category]",
      function () {
        return require("private-next-pages/news/category/[category].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/category/[category]"])
      });
    }
  